<template>
    <footer class="one-footer-area pt-100">
        <div class="container">
            <div class="row">

                <!-- LOGO -->
                <div class="col-sm-6 col-lg-3">
                    <div class="footer-item">
                        <div class="footer-logo">
                            <a href="#">
                                <img src="../../assets/img/jill_icon_blue.png" alt="Logo">
                            </a>
                            <p>{{ $t('footer.company') }}<br> {{ $t('footer.location') }}</p>

                            <ul>
                                <li><a target="_blank" href="https://www.facebook.com/"><i class='bx bxl-facebook'></i></a></li>
                                <li><a target="_blank" href="https://www.twitter.com/"><i class='bx bxl-twitter'></i></a></li>
                                <li><a target="_blank" href="https://www.linkedin.com/in/michel-conesa-b4647b22/"><i class='bx bxl-linkedin'></i></a></li>
                                <li><a target="_blank" href="https://www.instagram.com/creativa360contacto/"><i class='bx bxl-instagram'></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <!-- SERVICIOS -->
                <div class="col-sm-6 col-lg-3">
                    <div class="footer-item">
                        <div class="footer-address">
                            <h3>{{ $t('footer.about') }}</h3>
                            <ul>
                                <li><i class='bx bx-globe'></i><a href="#contact-strip">{{ $t('footer.services.web') }}</a></li>
                                <li><i class='bx bx-bullseye'></i><a href="#contact-strip">{{ $t('footer.services.ads') }}</a></li>
                                <li><i class='bx bx-trending-up'></i><a href="#contact-strip">{{ $t('footer.services.seo') }}</a></li>
                                <li><i class='bx bx-share-alt'></i><a href="#contact-strip">{{ $t('footer.services.social') }}</a></li>
                                <li><i class='bx bx-palette'></i><a href="#contact-strip">{{ $t('footer.services.branding') }}</a></li>
                                <li><i class='bx bx-send'></i><a href="#contact-strip">{{ $t('footer.services.cta') }}</a></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <!-- CONTACTO -->
                <div class="col-sm-6 col-lg-3">
                    <div class="footer-item">
                        <div class="footer-address">
                            <h3>{{ $t('footer.contact') }}</h3>
                            <ul>
                                <li>
                                    <i class='bx bx-phone-call'></i>
                                    <a href="tel:+34 623 61 51 28">+34 623 61 51 28</a>
                                </li>
                                <li>
                                    <i class='bx bx-message-square-detail'></i>
                                    <a href="mailto:contacto@creativa360.es">contacto@creativa360.es</a>
                                </li>
                                <li>
                                    <i class='bx bx-current-location'></i>
                                    {{ $t('footer.location2') }}
                                </li>
                                <li>
                                    <i class='bx bx-planet'></i>
                                    {{ $t('footer.support') }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <!-- POLÍTICAS -->
                <div class="col-sm-6 col-lg-3">
                    <div class="footer-item">
                        <div class="footer-address">
                            <h3>{{ $t('footer.policies') }}</h3>
                            <ul>
                                <li><i class='bx bx-file'></i><a href="/sobrenosotros">{{ $t('footer.policy.privacy') }}</a></li>
                                <li><i class='bx bx-lock-alt'></i><a href="/sobrenosotros">{{ $t('footer.policy.cookies') }}</a></li>
                                <li><i class='bx bx-book-alt'></i><a href="/sobrenosotros">{{ $t('footer.policy.legal') }}</a></li>
                                <li><i class='bx bx-shield'></i><a href="/sobrenosotros">{{ $t('footer.policy.terms') }}</a></li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>

            <!-- COPYRIGHT -->
            <div class="copyright-area">
                <div class="row align-items-center">
                    <div class="col-lg-6">
                        <div class="copyright-item">
                            <ul>
                                <li><img src="../../assets/img/footer/visa.jpg" alt=""></li>
                                <li><img src="../../assets/img/footer/master-card.jpg" alt=""></li>
                                <li><img src="../../assets/img/footer/paypal.jpg" alt=""></li>
                                <li><img src="../../assets/img/footer/skrill.jpg" alt=""></li>
                                <li><img src="../../assets/img/footer/master-card2.jpg" alt=""></li>
                                <li><img src="../../assets/img/footer/visa2.jpg" alt=""></li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="copyright-item">
                            <p>&copy; {{ currentYear }} Creativa360</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </footer>
</template>

<script>
export default {
    name: 'Footer',
    data() {
        return {
            currentYear: new Date().getFullYear(),
        };
    }
}
</script>